import { Grid } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import Button from '../../../Buttons/Button';
import Input from '../../../InputFields/Input';
import SelectInput from '../../../InputFields/SelectInput/SelectInput';
import "./AddSystemPopUp.scss";
import { POP_UPS_TRANSLATION } from '../../../../../constants/translations/customer/PopUps/PopUps';
import { systemActionsCreator } from '../../../../../actions/customer/orderProcessSystemActions';
import { useDispatch, useSelector } from 'react-redux';
import { useGetSystemsRelatedToLayer } from '../../../../../hooks/useGetSystemsRelatedToLayer';
import { add, cancel, addSystemInputs, addMobile, cancelMobile, addDesktop, cancelDesktop } from "./AddSystemPopUpStatic";
import { generalPostRequest } from '../../../../../functions/api/general'
import Loader from '../../../../LoaderNew/Loader'

export default function AddSystemPopUp(props) {
    const { handleShowPopUp, view, name, mode, layer,
        parentSystemId, setParentSystemId, customerId, selected_process } = props;
    const [isLoading, setIsLoading] = useState(false);

    const selectedSystem = useSelector((state) => state.orderProcessSystemReducer.singleSystem);

    const systemNameToEdit = selectedSystem?.system_name;
    const locationDescriptionToEdit = selectedSystem?.location_description;
    const floorToEdit = selectedSystem?.location_floor;
    const heightToEdit = selectedSystem?.height;
    const widthToEdit = selectedSystem?.width;
    const parentSystemIdForEditSystem = selectedSystem?.parent_system_id;
    const layerForEditSystem = selectedSystem?.layer;
    const systemIdForEditSystem = selectedSystem?.system_id;

    const [inputValue, setInputValue] = useState({
        systemName: mode === 'edit' ? systemNameToEdit && typeof (systemNameToEdit) === 'object' ? systemNameToEdit.name : systemNameToEdit : '',
        systemNameError: false,
        locationDescription: mode === 'edit' ? locationDescriptionToEdit && locationDescriptionToEdit : '',
        locationDescriptionError: false,
        floor: mode === 'edit' ? floorToEdit && floorToEdit : '',
        floorError: false,
        height: mode === 'edit' ? heightToEdit && typeof (heightToEdit) === 'object' ? heightToEdit.name : heightToEdit : '',
        heightError: false,
        width: mode === 'edit' ? widthToEdit && typeof (widthToEdit) === 'object' ? widthToEdit.name : widthToEdit : '',
        widthError: false,
    });

    const templateSystems = useGetSystemsRelatedToLayer(layer);

    const systemSelectionOptions = templateSystems.map((systemOption) => {
        return {
            id: systemOption._id,
            name: systemOption.description
        }
    })

    const dispatch = useDispatch();

    const handleAddSystem = async (systemBody) => {
        let response = await generalPostRequest(systemBody, `/system/customer-page/add-new-actual-system`)
        return response;
    }

    const handleEditSystem = async (systemBody) => {
        let response = await generalPostRequest(systemBody, `/system/customer-page/edit-actual-system`)
        return response;
    }

    const handleChange = (name, value) => {
        setInputValue((prev) => ({
            ...prev,
            [name]: value,
        }))
    }

    const submitForm = async (sys_id) => {
        setIsLoading(true);
        if (mode === 'edit') {
            try {
                let response = await handleEditSystem({
                    "system_id": inputValue.systemName.id,
                    "actual_system_name": inputValue.systemName.name,
                    "location_floor": inputValue.floor,
                    "location_description": inputValue.locationDescription,
                    "height": inputValue.height,
                    "width": inputValue.width,
                    "system_type": "",
                    "parent_system_id": parentSystemId ? parentSystemId : null,
                    "customer_id": customerId,
                    "layer": layer && parentSystemId ? layer : 1,
                    order_id: selected_process?.orderId || "",
                    _id: sys_id
                })
                console.log('Response from handleEditSystem:', response);
                if (response) {
                    const matchedSystem = response.result.find(
                        item => item._id === sys_id
                    );
                    console.log('matchedSystem:', matchedSystem);
console.log('sys_id:', sys_id);
console.log('response.result:', response.result);
                    dispatch(systemActionsCreator.editSystem(matchedSystem))
                }
            } catch (error) {
                console.error('An error occurred in handleEditSystem:', error);
            } finally {
                setIsLoading(false);
            }
        } else {
            try {
                let response = await handleAddSystem({
                    "system_id": inputValue.systemName.id,
                    "actual_system_name": inputValue.systemName.name,
                    "location_floor": inputValue.floor,
                    "location_description": inputValue.locationDescription,
                    "height": inputValue.height,
                    "width": inputValue.width,
                    "system_type": "",
                    "parent_system_id": parentSystemId ? parentSystemId : null,
                    "customer_id": customerId,
                    "layer": layer && parentSystemId ? layer : 1,
                    order_id: selected_process?.orderId || "",
                })
                console.log('Response from handleAddSystem:', response);
                if (response) {
                    const apiSystem = response.result.at(-1);
                    dispatch(systemActionsCreator.addSystem({
        parentId: apiSystem.parent_system_id,
        systemName: apiSystem.system_name,
        locationDescription: apiSystem.location_description,
        floor: apiSystem.location_floor,
        height: apiSystem.height,
        width: apiSystem.width,
        layer: apiSystem.layer,
        order_id: apiSystem.order_id,
    }))
                }
            } catch (error) {
                console.error('An error occurred in handleAddSystem:', error);
            } finally {
                setIsLoading(false);
            }
        }
        handleShowPopUp();
        if (view === 'mobile') {
            dispatch(systemActionsCreator.showSystemsPopup(false))
        }
        if (setParentSystemId) {
            setParentSystemId(() => null);
        }
    }

    const addSystemInputsToSend = {
        ...addSystemInputs,
        systemName: {
            ...addSystemInputs.systemName,
            selectOptions: systemSelectionOptions,
            handleChange: handleChange,
            value: inputValue.systemName || { name: '' },
            placeholder: mode === 'edit' ? (typeof (systemNameToEdit) === 'object' ? systemNameToEdit.name : systemNameToEdit) : POP_UPS_TRANSLATION.CHOOSE,
            error: inputValue.systemNameError,
            errorText: inputValue.systemNameError && 'system has error'
        },
        locationDescription: {
            ...addSystemInputs.locationDescription,
            onChange: handleChange,
            value: inputValue.locationDescription,
            placeholder: mode === 'edit' ? locationDescriptionToEdit : POP_UPS_TRANSLATION.ENTER,
            error: inputValue.locationDescriptionError,
            errorText: inputValue.locationDescriptionError && 'location has error'
        },
        floor: {
            ...addSystemInputs.floor,
            onChange: handleChange,
            value: inputValue.floor,
            placeholder: mode === 'edit' ? floorToEdit : POP_UPS_TRANSLATION.ENTER,
            error: inputValue.floorError,
            errorText: inputValue.floorError && 'floor has error'
        },
        height: {
            ...addSystemInputs.height,
            onChange: handleChange,
            value: inputValue.height,
            placeholder: mode === 'edit' ? heightToEdit : POP_UPS_TRANSLATION.ENTER,
            error: inputValue.heightError,
            errorText: inputValue.heightError && 'height has error'
        },
        width: {
            ...addSystemInputs.width,
            onChange: handleChange,
            value: inputValue.width,
            placeholder: mode === 'edit' ? widthToEdit : POP_UPS_TRANSLATION.ENTER,
            error: inputValue.widthError,
            errorText: inputValue.widthError && 'width has error'
        }
    }

    return (
        <Grid className='addSystem__main' style={{ left: view == 'desktop' || view == 'desktop-popup' && '15%' }}>
            <Grid>
                <h4 className='addSystem__title'>{name}</h4>
            </Grid>
            <Grid className='addSystem__uploadedInfo'>
                {
                    selected_process?.customerName ? <Grid item xs={12} className='addSystem__uploadedInfo-row'>
                        <Grid item xs={6} className='addSystem__uploadedInfo-label'><span>{POP_UPS_TRANSLATION.CUSTOMER_NAME}</span></Grid>
                        <Grid item xs={6} className='addSystem__uploadedInfo-value'><span>{selected_process?.customerName}</span></Grid>
                    </Grid> : null
                }
                {
                    selected_process?.orderNumber ? <Grid item xs={12} className='addSystem__uploadedInfo-row'>
                        <Grid item xs={6} className='addSystem__uploadedInfo-label'><span>{POP_UPS_TRANSLATION.ORDER_NUMBER}</span></Grid>
                        <Grid item xs={6} className='addSystem__uploadedInfo-value'><span>{selected_process?.orderNumber}</span></Grid>
                    </Grid> : null
                }
            </Grid>
            <Grid sx={12} className='addSystem__inputsFields'>
                <Grid>
                    <SelectInput data={addSystemInputsToSend.systemName} view={view} />
                </Grid>
                <Grid className='addSystem__inputsRow'>
                    <Grid item xs={12} md={7}>
                        <Input data={addSystemInputsToSend.locationDescription} view={view} />
                    </Grid>
                    <Grid item xs={12} md={5} className='addSystem__inputsLeft'>
                        <Input data={addSystemInputsToSend.floor} view={view} />
                    </Grid>
                </Grid>
                <Grid className='addSystem__inputsRow'>
                    <Grid item xs={12} md={7}>
                        <Input data={addSystemInputsToSend.height} view={view} />
                    </Grid>
                    <Grid item xs={12} md={5} className='addSystem__inputsLeft'>
                        <Input data={addSystemInputsToSend.width} view={view} />
                    </Grid>
                </Grid>
            </Grid>
            <Grid className='addSystem__emptyBox'></Grid>
            {
                isLoading ? <Loader /> :
                    view === 'mobile' ? <Grid sx={12} className={`addSystem__btn__container`}>
                        <Button data={addMobile} handleClick={() => submitForm(selectedSystem?._id)} />
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <Button data={cancelMobile} handleClick={() => {
                            handleShowPopUp()
                            dispatch(systemActionsCreator.showSystemsPopup(false))
                        }} />
                    </Grid>
                        : view === 'desktop' || view === 'desktop-popup' ? <Grid sx={12} className='addSystem__btn__container'>
                            <Button data={addDesktop} handleClick={() => submitForm(selectedSystem?._id)} />
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <Button data={cancelDesktop} handleClick={() => handleShowPopUp()} />
                        </Grid>
                            : <Grid sx={12} className='addSystem__btn__container'>
                                <Button data={add} handleClick={() => handleShowPopUp()} />
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <Button data={cancelDesktop} handleClick={() => handleShowPopUp()} />
                            </Grid>
            }
        </Grid>
    )
}